<template>
    <div>
        <VerifiedLable
            :title="title"
            :tagnewid="tagnewid"
            :required="required"
            :disableMLtitle="disableMLtitle"
            :tooltipLabel="tooltipLabel"
            :tooltipPosition="tooltipPosition"
            :tooltipType="tooltipType"
            :tooltipSize="tooltipSize"
            :tooltipMultilined="tooltipMultilined"
        />
        <button
            @click="iconsList()"
            class="button"
            :class="{ invalid: invalided == true, 'disabled-select': disabled }"
            :loading="true"
            ref="iconButton"
            :disabled="disabled"
        >
            <!-- id="iconButton" -->
            <span v-show="loading == false">
                <span v-if="showIcon == false">{{
                    $t("selecione-um-icone")
                }}</span>
                <span v-if="showIcon == true" ref="icone">
                    {{ $t("selecionado") }}
                    <i
                        class="fa-lg ml-2"
                        :class="iconClass != '' ? iconClass.toLowerCase() : ''"
                    ></i>
                </span>
            </span>
            <span v-show="loading == true">
                <i class="fa-lg ml-2 fas fa-spinner fa-pulse"></i>
            </span>

            <div class="icons-select" v-show="showIconsList == true">
                <div
                    v-for="(i, index) in icons"
                    :key="index"
                    @click.stop.prevent="selectIcon(i)"
                >
                    <i class="fa-lg" :class="[i.pack, 'fa-' + i.class]"></i>
                </div>
            </div>
        </button>
        <!-- <b-icon class="file-icon" :icon="icon.class" :pack="icon.pack"></b-icon> -->
        <span
            class="validation"
            v-text=" getT(msg, '')"
            v-if="invalided"
        />
    </div>
</template>

<script>
import VerifiedLable from "@/components/shared/VerifiedLable.vue";

export default {
    components: {
        VerifiedLable,
    },
    props: {
        msg: {
            default: "msg-campo-obrigatorio",
            type: String,
        },
        invalid: {
            default: false,
            type: Boolean,
        },
        iconClass: {
            default: "",
            type: String,
        },
        icons: {
            type: Array,
            default: () => [
                { pack: "fas", class: "battery-half" },
                { pack: "fas", class: "bed" },
                { pack: "fas", class: "box-open" },
                { pack: "fas", class: "briefcase" },
                { pack: "fas", class: "building" },
                { pack: "fas", class: "bus-alt" },
                { pack: "fas", class: "calculator" },
                { pack: "fas", class: "calendar-alt" },
                { pack: "fas", class: "car" },
                { pack: "fas", class: "shopping-cart" },
                { pack: "fas", class: "gas-pump" },
                { pack: "fas", class: "coffee" },
                { pack: "far", class: "credit-card" },
                { pack: "fas", class: "drumstick-bite" },
                { pack: "fas", class: "plane-departure" },
                { pack: "fas", class: "headset" },
                { pack: "fas", class: "home" },
                { pack: "far", class: "hospital" },
                { pack: "fas", class: "hotel" },
                { pack: "fas", class: "luggage-cart" },
                { pack: "fas", class: "map-marked-alt" },
                { pack: "fas", class: "mobile-alt" },
                { pack: "fas", class: "mug-hot" },
                { pack: "fas", class: "newspaper" },
                { pack: "fas", class: "phone" },
                { pack: "fas", class: "poll" },
                { pack: "fas", class: "shopping-basket" },
                { pack: "fas", class: "shuttle-van" },
                { pack: "fas", class: "store" },
                { pack: "fas", class: "subway" },
                { pack: "fas", class: "suitcase-rolling" },
                { pack: "fas", class: "taxi" },
                { pack: "fas", class: "tools" },
                { pack: "fas", class: "truck-moving" },
                { pack: "fas", class: "tv" },
                { pack: "fas", class: "utensils" },
                { pack: "fas", class: "wallet" },
                { pack: "fas", class: "wrench" },
            ],
        },
        disabled: {
            default: false,
            type: Boolean,
        },
        title: {
            default: "",
            type: String,
        },
        // Id do tagnew referente ao .env na raiz do sistema
        tagnewid: undefined,
        // O título fica com a cor primária da empresa e com um asterisco após o título
        required: {
            type: Boolean,
            default: false,
        },
        /* Caso tenha uma informação adicional sobre o campo */
        tooltipLabel: {
            type: String,
            default: null,
        },
        tooltipPosition: {
            type: String,
            default: "is-right",
        },
        tooltipType: {
            type: String,
            default: "is-dark",
        },
        tooltipMultilined: {
            type: Boolean,
            default: true,
        },
        tooltipSize: {
            type: String,
            default: "is-large",
        },
        disableMLtitle: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            showIcon: false,
            showIconsList: false,
            icon: {
                class: null,
                pack: null,
            },
            invalided: false,
            loading: false,
        };
    },
    created() {
        this.start();
    },
    watch: {
        invalid(e) {
            if (e) this.invalided = true;
        },
        iconClass(novo, old) {
            if(this.isNull(old)) this.start();
        }
    },
    methods: {
        start() {
            setTimeout(() => {
                let vd = this;
                document.addEventListener("click", function (e) {
                    let isClickInsideElement = null;
                    if (vd.$refs.iconButton) {
                        isClickInsideElement = vd.$refs.iconButton.contains(
                            e.target
                        );
                    }
                    if (!isClickInsideElement && vd.showIconsList)
                        vd.iconsList();
                });
                if (this.iconClass != "") {
                    this.showIcon = true;
                }
            }, 300);
        },
        iconsList() {
            this.showIconsList = !this.showIconsList;
            this.invalided = this.iconClass == "" && !this.showIconsList;
        },
        selectIcon(icon) {
            if (this.$refs.icone) this.$refs.icone.innerHTML = "";
            this.showIcon = false;
            this.loading = true;
            this.icon.class = icon.class;
            this.icon.pack = icon.pack;
            let iconClassTemp = icon.pack + " fa-" + icon.class;
            this.$emit("changeIcon", iconClassTemp);
            setTimeout(() => {
                this.loading = false;
                this.showIcon = true;
                this.showIconsList = !this.showIconsList;
            }, 400);
        },
    },
};
</script>

<style lang="scss">
.button {
    width: 100%;
    height: 36px;
}
.icons-select {
    position: absolute;
    left: 0;
    right: 0;
    top: 40px;
    overflow-y: scroll;
    height: 150px; // Ajustado para se comportar como uma linha e não ficar desagradável quando em poucos icones
    border: solid 1px #dbdbdb;
    background-color: rgb(245, 245, 245);
    border-radius: 4px;
    display: flex;
    flex-wrap: wrap;
    align-content: baseline;
    z-index: 101;
    box-shadow: 1px 3px 8px 0px rgba(58, 58, 58, 0.7);
}
.icons-select div {
    min-width: 45px;
    max-height: 45px;
    padding: 8px;
    border: solid 1px #dbdbdb;
    background-color: #fff;
    border-radius: 3px;
    margin: 2px;
    transition: 0.1s;
}
.icons-select div:hover {
    cursor: pointer;
    background-color: rgb(63, 62, 62);
    color: #fff;
}
span.validation {
    font-size: 8px;
    color: $red;
    display: block;
    font-weight: 600;
}
.invalid {
    border: 1px solid $red-alert !important;
}
.disabled-select {
    color: #757575 !important;
    opacity: 1 !important;
    background-color: rgba(208, 207, 207, 0.6) !important;
}
</style>